'use client'
import { useEffect } from 'react'

export const useDocumentClick = (onClickDocument: (e: MouseEvent) => void) => {
  useEffect(() => {
    document.addEventListener('click', onClickDocument)

    return () => {
      document.removeEventListener('click', onClickDocument)
    }
  }, [onClickDocument])
}
